import { NavigationEffects } from './effects/navigation.effects';
import { NotificationEffects } from './effects/notification.effects';
import { SentryEffects } from './effects/sentry.effects';
import { SingleTenantEffects } from './effects/single-tenant.effects';
import { TranslateEffects } from './effects/translate.effects';

export const appEffects = [SingleTenantEffects, NavigationEffects, TranslateEffects, SentryEffects, NotificationEffects];
